import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../common/models/common.model';
import { ProductPackaging } from './product.model';
import { buildHttpParams } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class ProductPackagingService {
  private _baseUrl: string = 'product-packagings';

  constructor(private _apiService: ApiService) {}

  list(query: Record<string, string> | null = null): Observable<PaginatedResponse<ProductPackaging>> {
    const params = buildHttpParams(query);
    return this._apiService.get(this._baseUrl + '/', params);
  }

  get(id: string): Observable<ProductPackaging> {
    return this._apiService.get(this._baseUrl + '/' + id + '/');
  }

  delete(id: string): Observable<void> {
    return this._apiService.delete(`${this._baseUrl}/${id}/`);
  }

  post(reqBody: any): Observable<ProductPackaging> {
    return this._apiService.post(`${this._baseUrl}/`, reqBody);
  }

  // Post with FormData for file uploads
  postFormData(formData: FormData): Observable<ProductPackaging> {
    return this._apiService.post(`${this._baseUrl}/`, formData);
  }

  patch(id: string, reqBody: any): Observable<ProductPackaging> {
    return this._apiService.patch(`${this._baseUrl}/${id}/`, reqBody);
  }

  // Patch with FormData for file uploads
  patchFormData(id: string, formData: FormData): Observable<ProductPackaging> {
    return this._apiService.patch(`${this._baseUrl}/${id}/`, formData);
  }

  // Get packagings for a specific product
  getByProduct(productId: string): Observable<PaginatedResponse<ProductPackaging>> {
    return this.list({ product: productId });
  }
}
